export const MAPPING_WRITE_INIT = 'MAPPING_WRITE_INIT'
export const MAPPING_WRITE_SAVE = 'MAPPING_WRITE_SAVE'
export const MAPPING_WRITE_UPDATE = 'MAPPING_WRITE_UPDATE'
export const MAPPING_WRITE_SELECT_TAB = 'MAPPING_WRITE_SELECT_TAB'
